module.exports = __webpack_public_path__ + "img/debang.805a38a3.png";